export const getPostPreviewWidth = () => 400;

export const POST_PREVIEW_ELEMENT_CONTEXT = "hoverPreview";
